
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 260 120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M133.257 0C118.03 0 101.521 45.867 98.96 73.318c27.535 5.301 50.354 7.791 69.257 8.391.029-.689.047-1.391.047-2.105C168.265 53.797 149.816 0 133.257 0zM260 91.834C180.47 140.98-17.143 123.117 1.194 59.17 292.77 150.625 254.867 19.158 260 91.834z"}})])
          )
        }
      }
    